import { getBluryAndLazyImageUrl } from "@website-builder/utilities-index";
import { getImageConfig } from "@website-builder/utilities-index";

export default (props) => {
	const {
		hashLink,
		pageSection,
		hideInMobile,
		backgroundImage,
		backgroundColor,
		alignBackgroundImage,
		mobileBackgroundImage,
		updateBottomSpacing,
		updateTopSpacing,
		hideOnDevices,
	} = props;
	const bgcolor = backgroundColor;
	let imageConfig = {},
		mobileImageConfig = {};
	if (backgroundImage && backgroundImage.image) {
		imageConfig = getImageConfig(backgroundImage);
		imageConfig = {
			...imageConfig,
			...getBluryAndLazyImageUrl(imageConfig.imageUrl),
		};
	}
	if (mobileBackgroundImage && mobileBackgroundImage.image) {
		mobileImageConfig = getImageConfig(mobileBackgroundImage);
		mobileImageConfig = {
			...mobileImageConfig,
			...getBluryAndLazyImageUrl(mobileImageConfig.imageUrl),
		};
	}

	return {
		hashLink,
		pageSection,
		hideInMobile,
		imageConfig,
		bgcolor,
		mobileImageConfig,
		alignBackgroundImage,
		updateBottomSpacing,
		updateTopSpacing,
		hideOnDevices,
	};
};
